<section class="px-container pt-16 min-h-full-nav" *ngIf="notizia">
    <!-- <div class="bg-dark my-20 w-full h-48"></div> -->
    <div class="flex md:flex-row flex-col gap-20 lg:gap-10 mb-24">
        <div class="flex flex-col gap-4 w-full md:w-8/12">
            <span class="bg-accent p-2 text-sm self-start">
                {{notizia.data_creazione | date: 'EEEE dd MMMM yyyy' | titlecase }}
            </span>
            <h1 class="text-3xl md:text-5xl lg:text-6xl break-words">{{notizia.titolo | titlecase}}</h1>
            <p class="font-mono desc mt-8" [class.text-gray-500]="notizia.descrizione.length == 0" [innerHTML]="notizia.descrizione || 'Nessuna info disponibile per questa notizia'"></p>
        </div>
        <div class="md:pl-8 w-full md:w-4/12">
            <div class="flex justify-between mb-8 align-middle">
                <h1 class="text-2xl md:text-4xl">Altre News</h1>
                <a class="cta-link self-start" routerLink="/news">tutte le notizie</a>
            </div>
            <ng-container *ngFor="let news of notizie">
                <app-news-box [notizia]="news" class="block relative mb-4 h-auto"></app-news-box>
            </ng-container>
        </div>
    </div>
</section>